<div class="col-lg-12 retalk-home-blq mb-md-flex-dir-col mb-sm-5">

    <div class="col-lg-3 col-md-4 col-sm-12 col-12 px-lg-3 px-md-0 retalk-home-blq-inner">
         <p class="text-uppercase">{{threeColAreaButton_params.preTitle}}</p>
         <h1>{{threeColAreaButton_params.title}}</h1>
    </div>

    <div class="col-lg-3 col-md-4 col-sm-12 col-12 px-lg-3 px-md-0 retalk-home-blq-inner">
      
         <p class="mt-lg-5 mt-md-0 mb-lg-0">{{threeColAreaButton_params.mainText}}</p>
    </div>

      <div class="col-lg-4 col-md-4 col-sm-12 col-12 px-lg-3 px-md-0 retalk-home-blq-inner">
          <a class="btn btn-rco" routerLink="{{threeColAreaButton_params.mainButtonLink}}"><p>{{threeColAreaButton_params.mainButtonText}}</p></a>
    </div>
  
  
   
</div>